var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignIconAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3472 6.22742L29.2996 4.39209C23.0258 10.4501 18.2051 15.2502 14.9637 18.9839C12.147 22.2689 11.9128 23.0161 12.489 23.5705C12.6359 23.714 12.8357 23.792 13.0423 23.7829C13.956 23.6623 14.8191 23.2939 15.5399 22.7177C16.3984 22.1266 17.1606 21.4069 17.801 20.584L25.0528 13.8212L32.1989 7.1445L31.3472 6.22742Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4991 6.07756H33.3928C33.0262 6.03693 32.7002 5.82262 32.5179 5.50154C32.3689 5.33097 32.1762 5.09635 31.8356 4.75495L31.1533 4.22164C30.7627 4.00889 30.4992 3.6188 30.4492 3.17637C30.4492 2.19516 31.5367 1.59779 32.0283 1.38452C33.1158 0.89391 34.9938 0.723075 35.7615 1.83241C36.2219 2.69305 36.1386 3.74328 35.548 4.52033C35.1584 5.34166 34.3949 5.92261 33.4991 6.07756Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40686 22.8729C5.94281 20.736 1.57502 17.4524 2.02771 14.1884C2.54457 10.4616 9.00169 9.24256 8.88159 6.3488C8.82866 5.07404 7.48787 3.20037 0.638672 1.10229",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIconAdmin);
export default __webpack_public_path__ + "static/media/design-icon-admin.a2fcda3547a0d4bc58188136822f44ea.svg";
export { ForwardRef as ReactComponent };